/* tslint:disable */
/* eslint-disable */
/* @relayHash 765c9d2e4801edf5ecb0c97d91c051b9 */

import { ConcreteRequest } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type DesignProfileStatusMutationInput = {
    firmId?: number | null;
    serviceId?: number | null;
    status?: DesignProfileStatus | null;
    clientMutationId?: string | null;
};
export type profileStatusMutationVariables = {
    input: DesignProfileStatusMutationInput;
};
export type profileStatusMutationResponse = {
    readonly designProfileStatusMutation: {
        readonly tradeFirm: {
            readonly profileStatus: DesignProfileStatus | null;
        } | null;
    } | null;
};
export type profileStatusMutation = {
    readonly response: profileStatusMutationResponse;
    readonly variables: profileStatusMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "profileStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileStatusMutationPayload",
        "kind": "LinkedField",
        "name": "designProfileStatusMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "profileStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileStatusMutationPayload",
        "kind": "LinkedField",
        "name": "designProfileStatusMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "kind": "LinkedField",
            "name": "tradeFirm",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/306.0.0-2021-03-15T23:43:35.521Z/profileStatusMutation",
    "metadata": {},
    "name": "profileStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '35c7cbeb9630923afa49ed1d22656d45';
export default node;
